const Heading = {
  baseStyle: {},
  variants: {
    display: {
      fontWeight: "800",
      fontSize: "60px",
      lineHeight: "80px",
      fontFamily: "Poppins",
    },
  },
  global: {
    h1: {
      fontWeight: "800",
      fontSize: "48px",
      lineHeight: "62px",
      fontFamily: "Poppins",
    },
    h2: {
      fontWeight: "700",
      fontSize: "34px",
      lineHeight: "40px",
      fontFamily: "Poppins",
    },
    h3: {
      fontWeight: "700",
      fontSize: "24px",
      lineHeight: "32px",
      fontFamily: "Poppins",
    },
    h4: {
      fontWeight: "700",
      fontSize: "20px",
      lineHeight: "28px",
      fontFamily: "Poppins",
    },
    h5: {
      fontWeight: "700",
      fontSize: "18px",
      lineHeight: "24px",
      fontFamily: "Poppins",
    },
    h6: {
      fontWeight: "700",
      fontSize: "16px",
      lineHeight: "20px",
      fontFamily: "Poppins",
    },
  },
};

export default Heading;
